// src/components/Login.js
import React, { useState } from 'react';
import OrderService from './service/OrderService'; // Ensure the path is correct
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Tooltip } from 'primereact/tooltip';
import './Login.css'; // Import custom CSS for additional styling
import logo from '../assets/logo.png'; // Ensure you have a logo image at this path

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
  
    try {
      const data = await OrderService.login(username, password);
      localStorage.setItem('token', data.token); // Store access token
      localStorage.setItem('refreshToken', data.refreshToken); // Store refresh token
      navigate('/'); // Redirect to the main page after login
    } catch (err) {
      setError('Invalid username or password');
    }
  };
  

  return (
    <div className="login-page">
      <div className="login-form-section">
        <Card
          className="login-card"
          title={
            <img
              src={logo}
              alt="Logo"
              className="logo"
              style={{
                width: '250px',
                height: '250px',
                alignSelf: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            />
          }
        >
          {error && <Message severity="error" text={error} className="mb-3" />}
          <form onSubmit={handleSubmit}>
            <div className="p-field mb-4">
              <label htmlFor="username" className="p-d-block">
                Username
              </label>
              <span className="p-input-icon-left">
                <i className="pi pi-envelope" />
                <InputText
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="p-inputtext-lg"
                />
              </span>
            </div>
            <div className="p-field mb-4">
              <label htmlFor="password" className="p-d-block">
                Password <br />
              </label>
              <span className="p-input-icon-left">
                <i className="pi pi-lock" />
                <Password
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  feedback={false}
                  required
                  toggleMask
                  className="p-inputtext-lg"
                />
              </span>
            </div>
            {/* Move the button inside the form */}
            <div className="button-container">
              <Button
                label="Login"
                icon="pi pi-sign-in"
                type="submit"
                className="p-button-danger"
              />
            </div>
          </form>
        </Card>
        <Tooltip target=".p-button" position="top" />
      </div>
    </div>
  );
};

export default Login;
